// @vue/component
export default {
  name: 'ReportsFormExportItemCampaign',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: '',
      projectUuid: '',
      rules: [
        { required: true, validator: this.__validateCampaignValue },
      ],
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/projects/list',
        'campaign/list',
      ]);
    },
    getProjectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    getCampaignList() {
      if (this.projectUuid !== '') return this.$store.getters['campaign/list'].records;
      return [];
    },
  },

  watch: {
    projectUuid(newValue) {
      if (this.projectUuid !== '') this.$store.dispatch('campaign/getListByProject', newValue);
    },
  },

  created() {
    this.$store.dispatch('client/projects/getList');
  },

  methods: {
    __validateCampaignValue(rule, value, callback) {
      if (value !== '') callback();
      else callback(new Error('Nie wybrano kampanii'));
      callback();
    },
  },
};
